import { Injectable } from '@angular/core';
import { UsersRestrictionService } from '../restrictions/users-restriction.service';
import { ExamModeRestrictionsService } from './exam-mode-restrictions.service';
import { ModalWindowService } from '../ui/modal-window.service';
import { FeatureRestrictionService } from '../restrictions/feature-restriction.service';
import { TimeRestrictionService } from '../restrictions/time-restriction.service';
import { ExtraDocumentsRestrictionService } from '../restrictions/extra-documents-restriction.service';
import { CurrentUiStoreService } from '../ui/current-ui-store.service';
import { AsgardFeatureNames } from 'src/models/AsgardFeatures';
import { AuthService } from '../auth/auth.service';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { MessageDialogActionColor, MessageDialogComponent, MessageDialogData } from '../../components/dialogs/message-dialog/message-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { ToastrDialogService } from '../toastr-dialog.service';
import { CloudConnectionService } from '../cloud-connection/cloud-connection.service';
import { RequestTypeEnum, ToastrActionEnum, ToastrStringsEnum } from 'src/app/utils/enums';
import { SpinnerDialogComponent } from 'src/app/components/dialogs/spinner-dialog/spinner-dialog.component';
import { TranslateService } from '@ngx-translate/core';
import { BaseApiService } from '../auth/base-api.service';
import { AccountService } from '../auth/account.service';
import { ExamEndingType } from '../restrictions/enums';
import { OverviewExamsComponent } from 'src/app/components/examMode/overview-exams/overview-exams.component';
import { ExamPropertiesTabNames } from './enums/properties-tab-names';
import { ExamSettingsTabService } from './exam-settings-tab.service';
import { WolandBaseDriveAuthService } from '../cloud-connection/base-drive.auth.service';
import { ExamPropertiesType } from 'src/app/components/examMode/exam-properties/exam-properties.component';
import { IExamModel } from 'src/app/components/examMode/interfaces';
import { MAX_EXAM_SCHEDULE_DAYS } from 'src/app/components/examMode/constants';
@Injectable({
  providedIn: 'root'
})
export class ExamCreationService extends BaseApiService {
  examId?: number;

  constructor(
    public http: HttpClient,
    private examService: ExamModeRestrictionsService,
    private userRestrictionsService: UsersRestrictionService,
    private readonly modalService: ModalWindowService,
    private readonly featureRestrictionService: FeatureRestrictionService,
    private readonly timeRestrictionService: TimeRestrictionService,
    private readonly documentsRestrictionService: ExtraDocumentsRestrictionService,
    private readonly examModeRestrictionsService: ExamModeRestrictionsService,
    private readonly uiStoreService: CurrentUiStoreService,
    private authService: AuthService,
    private readonly dialog: MatDialog,
    private toastrService: ToastrDialogService,
    private cloudConnectionService: CloudConnectionService,
    private readonly translateService: TranslateService,
    private readonly accountService: AccountService,
    private readonly examTabService: ExamSettingsTabService,
    private readonly wolandCloudDriveService: WolandBaseDriveAuthService,
  ) {
    super(http);
  }

  async sendExam(prepExam: IExamModel | undefined): Promise<void> {
    if (this.validateExamRestrictions(prepExam)) {

      await this.shoWarningSave();
      const userInfo = await this.accountService.getAccountInfo();
      const formData: any = new FormData();

      const examfile = this.documentsRestrictionService.examFile;

      if (examfile) {
        const additional = this.documentsRestrictionService.loadAdditionalDocument();
        additional.forEach(element => {
          formData.append('Attachments', element, element.name);
        });

        formData.append('ChangeUnlockCode', this.userRestrictionsService.unlockCode);

        const students = this.userRestrictionsService.selectedUsersData;
        students.forEach((element, index) => {
          formData.append(`Students[${index}].UserId`, element.userId);
          formData.append(`Students[${index}].Name`, element.name);
          formData.append(`Students[${index}].UserName`, element.userName);
          formData.append(`Students[${index}].Email`, element.email);
        });

        if (this.examId) {
          formData.append('id', this.examId);
          formData.append('CreateDate', prepExam!.createDate);
        } else {
          formData.append('CreateDate', new Date().toISOString());
        }
        var timeRestriction = this.timeRestrictionService.getTimeRestrictions()[0];

        if (timeRestriction) {
          let startFromDate = new Date(`${timeRestriction.day} ${timeRestriction.startFromTime}`);
          formData.append('ExamDate.startFromDate', startFromDate.toISOString());

          let startUntilDate = new Date(`${timeRestriction.day} ${timeRestriction.startUntilTime}`);
          formData.append('ExamDate.startUntilDate', startUntilDate.toISOString());

          formData.append('ExamEndingType', timeRestriction.examEndingType);

          if (timeRestriction.examEndingType === ExamEndingType.EndDate && timeRestriction.endTime) {
            let endDate = new Date(`${timeRestriction.day} ${timeRestriction.endTime}`);
            formData.append('ExamDate.endDate', endDate.toISOString());
          }

          if (timeRestriction.examEndingType === ExamEndingType.Duration && timeRestriction.duration) {
            let duration = timeRestriction.duration;
            formData.append('ExamDate.duration', duration);
          }
        }

        // if create (prepExam undefined), get info from service
        // if edit, get info from prepExam
        const driveInfo = this.wolandCloudDriveService.wolandDriveInfo
        if (driveInfo && !prepExam) {
          formData.append('DriveInfo.UserName', driveInfo.userName);
          formData.append('DriveInfo.Email', driveInfo.email);
          formData.append('DriveInfo.CloudType', driveInfo.cloudType);
        } else if (prepExam) {
          formData.append('DriveInfo.UserName', prepExam.userName);
          formData.append('DriveInfo.Email', prepExam.email);
          formData.append('DriveInfo.CloudType', prepExam.cloudType);
        }

        formData.append('SupervisorInfo.Name', userInfo?.username);
        formData.append('SupervisorInfo.Email', userInfo?.email);

        formData.append('ExamName', this.cloudConnectionService.examName);
        formData.append('Subject', this.cloudConnectionService.subject);

        formData.append('IsAllowDraft', this.documentsRestrictionService.isAllowDraft);
        formData.append('IsStoreDraft', this.documentsRestrictionService.isStoreDraft);
        formData.append('ExamFile', examfile, examfile?.name);

        if (this.featureRestrictionService.preset) {
          formData.append('FeatureRestriction.Id', this.featureRestrictionService.preset.id);
          formData.append('FeatureRestriction.Name', this.featureRestrictionService.preset.name);
          this.featureRestrictionService.preset.features.forEach(element => {
            formData.append('FeatureRestriction.Features', element);
          });
        }

        const authInfo = this.authService.getAuthInfo();
        if (authInfo) {
          // start spinner
          const processDialog = this.dialog.open(SpinnerDialogComponent, { panelClass: 'spinner-dialog-container' });

          const url = environment.connectedApiUrls.woland + '/' + environment.apiVersions.woland + '/exam/saveExam';

          // save the exam
          return this.post<void>(url, formData, undefined, RequestTypeEnum.ExamCreate)
          .then(() => {
            this.toastrService.showToastrByType(ToastrActionEnum.Success, ToastrStringsEnum.ExamSaveSuccess, false);
            this.reset();
            this.endCreation();

            // open examOverview dialog
            this.modalService.createModalWindow(OverviewExamsComponent, {});
          })
          .finally(() => {
            processDialog.close();
          });

        }
      }
    }
  }

  validateExamRestrictions(prepExam: IExamModel | undefined): boolean {
    let validationResult = true;
    let timeRestriction = this.timeRestrictionService.getTimeRestrictions();
    if (timeRestriction?.length === 0) {
      this.toastrService.showToaster(
        ToastrActionEnum.Error,
        this.translateWarning('EXAM_VALIDATION_WARNING.CREATE_TIMESLOT'),
        this.translateWarning('EXAM_VALIDATION_WARNING.TITLE'));
      validationResult = false;

    } else if (timeRestriction[0].examEndingType == ExamEndingType.Duration && timeRestriction[0].duration  < 1) {
      this.toastrService.showToaster(
        ToastrActionEnum.Error,
        this.translateWarning('EXAM_VALIDATION_WARNING.DURATION_IS_EMPTY'));
      validationResult = false;

    } else if (this.timeRestrictionService.examInPast()) {
      this.toastrService.showToaster(
        ToastrActionEnum.Error,
        this.translateWarning('EXAM_VALIDATION_WARNING.TIMESLOT_IN_PAST'),
        this.translateWarning('EXAM_VALIDATION_WARNING.TITLE'));
      validationResult = false;

    }
    if (prepExam?.createDate && timeRestriction?.length > 0) {
      const maxDate = new Date(prepExam.createDate);
      maxDate.setDate(maxDate.getDate() + MAX_EXAM_SCHEDULE_DAYS);

      const startFromDate = new Date(`${timeRestriction[0].day} ${timeRestriction[0].startFromTime}`);
      if (startFromDate > maxDate) {
        this.toastrService.showToaster(
          ToastrActionEnum.Error,
          this.translateWarning('EXAM_VALIDATION_WARNING.EXAM_DATE_EXCEEDS_CREATE_DATE'),
          this.translateWarning('EXAM_VALIDATION_WARNING.TITLE'));
        validationResult = false;
      }
    }

    // in create (prepExam undefined), check wolandDriveInfo
    // in edit (prepExam), check prepExam
    if ((!prepExam && !this.wolandCloudDriveService.wolandDriveInfo)
     || (prepExam && (!prepExam.cloudType || !prepExam.userName || !prepExam.email))
    ) {
      this.toastrService.showToaster(
        ToastrActionEnum.Error,
        this.translateWarning('EXAM_VALIDATION_WARNING.CLOUD_DRIVE'),
        this.translateWarning('EXAM_VALIDATION_WARNING.TITLE'));
      validationResult = false;
    }

    if (this.cloudConnectionService.subject?.length === 0) {
      this.toastrService.showToaster(
        ToastrActionEnum.Error,
        this.translateWarning('EXAM_VALIDATION_WARNING.EXAM_SUBJECT'),
        this.translateWarning('EXAM_VALIDATION_WARNING.TITLE'));
      validationResult = false;
    }

    if (this.cloudConnectionService.examName?.length === 0) {
      this.toastrService.showToaster(
        ToastrActionEnum.Error,
        this.translateWarning('EXAM_VALIDATION_WARNING.EXAM_NAME_MISSING'),
        this.translateWarning('EXAM_VALIDATION_WARNING.TITLE'));
      validationResult = false;

    } if (this.documentsRestrictionService.examFile && this.documentsRestrictionService.examFile.name?.length > 60) {
      // errorsMessage.push(this.translateWarning('EXAM_VALIDATION_WARNING.EXAM_NAME_MISSING'));
      this.toastrService.showToaster(
        ToastrActionEnum.Error,
        this.translateWarning('EXAM_VALIDATION_WARNING.FILE_NAME_TOO_LONG'),
        this.translateWarning('EXAM_VALIDATION_WARNING.TITLE'));
      validationResult = false;

    } if (this.cloudConnectionService.examName?.length > 60) {
      // errorsMessage.push(this.translateWarning('EXAM_VALIDATION_WARNING.EXAM_NAME_MISSING'));
      this.toastrService.showToaster(
        ToastrActionEnum.Error,
        this.translateWarning('EXAM_VALIDATION_WARNING.EXAM_NAME_TOO_LONG'),
        this.translateWarning('EXAM_VALIDATION_WARNING.TITLE'));
      validationResult = false;

    } else {
      const regexp = new RegExp('^([a-zA-Z0-9][^*/<>?\\\\\"|:]*)$');
      if (!regexp.test(this.cloudConnectionService.examName)) {
        this.toastrService.showToaster(
          ToastrActionEnum.Error,
          this.translateWarning('EXAM_VALIDATION_WARNING.EXAM_NAME_SPECIAL'),
          this.translateWarning('EXAM_VALIDATION_WARNING.TITLE'));
        validationResult = false;
      }
    }

    return validationResult;
  }

  private translateWarning(msg: string): string {
    return this.translateService.instant(msg);
  }

  private shoWarningSave(): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      const data: MessageDialogData = {
        title: 'EXAM_SAVE_CONFIRMATION_DIALOG.TITLE',
        message: this.examId ? 'EXAM_SAVE_CONFIRMATION_DIALOG.MODIFY_MESSAGE' : 'EXAM_SAVE_CONFIRMATION_DIALOG.MESSAGE',
        actions: [
          {
            title: 'EXAM_SAVE_CONFIRMATION_DIALOG.CONFIRM',
            color: MessageDialogActionColor.Primary,
            handler: () => resolve()
          },
          {
            title: 'EXAM_SAVE_CONFIRMATION_DIALOG.CANCEL',
            color: MessageDialogActionColor.None,
            handler: () => reject('canceled')
          }
        ]
      };
      this.dialog.open(MessageDialogComponent, { data });
    });
  }

  testExam(activeTab: ExamPropertiesTabNames, examPropertiesType: ExamPropertiesType, prepExam: IExamModel): void {
    // hide the floating toolbar for the supervisor
    this.uiStoreService.setItemUnActive(AsgardFeatureNames.EXAM_CREATION_FLOATING_TOOLBAR);
    // start the test
    this.examService.testExam(activeTab, examPropertiesType, prepExam);
  }

  endCreation(): void {
    // close the exam properties window
    this.modalService.closeModal();
    // stop the exam creation
    this.examModeRestrictionsService.deActivateExamCreation();
    // hide the floating toolbar for the supervisor
    this.uiStoreService.setItemUnActive(AsgardFeatureNames.EXAM_CREATION_FLOATING_TOOLBAR);
    // reset properties in the services of each tab
    this.reset();

    // disable some items in the main menu
    const features = [
      AsgardFeatureNames.OPEN_DRIVE,
      AsgardFeatureNames.OPEN_DOC,
      AsgardFeatureNames.OCR_ON_FILE,
      AsgardFeatureNames.SCAN_OCR_DRIVE
    ];
    this.uiStoreService.enableState(features);
  }

  setupExamId(id: number) {
    this.examId = id;
  }

  public reset(): void {
    // reset all the exam properties tab services
    this.userRestrictionsService.reset();
    this.documentsRestrictionService.reset();
    this.featureRestrictionService.reset();
    this.timeRestrictionService.reset();
    this.examTabService.reset();
    this.cloudConnectionService.examName = '';
    this.cloudConnectionService.subject = '';
    this.examId = undefined;
  }
}
